import gql from 'graphql-tag';

export const GET_GIFT_CARD_META_DATA = gql`
  query GetGiftCardMetaData {
    operativeViewer {
      id
      giftcardItemId
      giftcardUniverseId
    }
  }
`;

export const GET_GIFT_CARDS = gql`
  query GetGiftCards($limit: Int, $after: Json, $filter: GiftcardSearchFilter) {
    operativeViewer {
      id
      giftcards(limit: $limit, after: $after, filter: $filter) {
        items {
          id
          shortcode
          createdAt
          activatedAt
          status
          expiresAt
          balance
          history
        }
        lastKey
      }
    }
  }
`;

export const GIFT_CARD_BY_SHORTCODE = gql`
  query GetGiftCardByShortCode($universeId: String!, $shortcode: String!) {
    Giftcard(universeId: $universeId, shortcode: $shortcode) {
      id
      shortcode
      createdAt
      activatedAt
      status
      expiresAt
      balance
      history
    }
  }
`;

export const GET_GIFT_CARD_PAYMENT = gql`
  query GetGiftCardPayment($universeId: String!, $shortcode: String!, $reference: String!) {
    Giftcard(universeId: $universeId, shortcode: $shortcode) {
      id
      payment(reference: $reference) {
        id
      }
    }
  }
`;

export const REFUND_GIFT_CARD_PAYMENT = gql`
  mutation RefundGiftCardPayment($transactionId: String!, $refundAmount: Int) {
    refundGiftcardPayment(transactionId: $transactionId, refundAmount: $refundAmount) {
      success
      message
      error
      giftcard {
        id
        balance
        history
      }
    }
  }
`;

export const PAY_WITH_GIFT_CARD = gql`
  mutation PayWithGiftCard(
    $universeId: String!
    $shortcode: String!
    $amount: Int!
    $reference: String!
    $venueId: String!
  ) {
    payWithGiftcard(
      universeId: $universeId
      shortcode: $shortcode
      amount: $amount
      reference: $reference
      venueId: $venueId
    ) {
      success
      message
      error
      transactionId
    }
  }
`;

export const CREATE_GIFT_CARD = gql`
  mutation CreateGiftCard(
    $universeId: String!
    $expiryInYears: Int!
    $emailOnCreate: String
    $initialBalance: Int
    $shortcode: String
    $emailDetails: EmailDetails
    $lang: String
  ) {
    createGiftcard(
      universeId: $universeId
      expiryInYears: $expiryInYears
      emailOnCreate: $emailOnCreate
      initialBalance: $initialBalance
      shortcode: $shortcode
      emailDetails: $emailDetails
      lang: $lang
    ) {
      success
      error
      giftcard {
        id
        shortcode
        status
        createdAt
        expiresAt
        activatedAt
        history
      }
    }
  }
`;

export const EMAIL_GIFT_CARD = gql`
  mutation EmailGiftCard(
    $universeId: String!
    $shortcode: String!
    $email: String!
    $emailDetails: EmailDetails
    $lang: String
  ) {
    emailGiftcard(
      universeId: $universeId
      shortcode: $shortcode
      email: $email
      emailDetails: $emailDetails
      lang: $lang
    ) {
      success
      error
    }
  }
`;

export const INCREASE_GIFT_CARD_BALANCE = gql`
  mutation IncreaseGiftCardBalance($universeId: String!, $shortcode: String!, $amount: Int!) {
    increaseGiftcardBalance(universeId: $universeId, shortcode: $shortcode, amount: $amount) {
      success
      error
      giftcard {
        id
        balance
      }
    }
  }
`;

export const ACTIVATE_GIFT_CARD = gql`
  mutation ActivateGiftCard($universeId: String!, $shortcode: String!) {
    activateGiftcard(universeId: $universeId, shortcode: $shortcode) {
      success
      error
      giftcard {
        id
        shortcode
        expiresAt
        activatedAt
      }
    }
  }
`;

export const GET_GIFT_CARD_ITEM = gql`
  query GetGiftCardItem($id: ID!) {
    item: Item(id: $id) {
      id
      vatRate
      titleLang {
        id
        se
        en
        es
        no
      }
      categories {
        id
        nameLang {
          id
          se
          en
          es
          no
        }
      }
    }
  }
`;
